/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
// Constants
import { Color } from "../../constants/Colors";
import { SVG_GRADIENT_BLUE } from '../Button/ButtonStyles';

export const useStyles = () => ({
    popoverRoot: css({
        zIndex: 12000 + ` !important`,
    }),
    menuRoot: css({
        overflow: "visible",
        borderRadius: 0,
        minWidth: 200,
        boxShadow: "0px 2px 29px 0px rgba(3, 3, 3, 0.15)",
    }),
    menuList: css({
        padding: 0,
    }),
    menuItemDestructive: css({
        height: 36,
        fontFamily: "roboto-light",
        fontSize: 12,
        color: Color.neutral[900],
        cursor: "pointer",
        display: "flex",
        overflow: "visible",
        "&:hover": {
            backgroundColor: Color.danger[300],
            color: Color.neutral[0],
            "& $listItemIconRoot": {
                color: Color.neutral[0],
            }
        },
    }),
    menuItem: css({
        height: 36,
        fontFamily: "roboto-light",
        fontSize: 12,
        color: Color.neutral[900],
        cursor: "pointer",
        display: "flex",
        overflow: "visible",
        "& a": {
            color: Color.neutral[900],
        },
        "&:hover": {
            backgroundColor: Color.neutral[100],
        },
        "&.Mui-disabled": {
            backgroundColor: Color.neutral[300],
            color: Color.neutral[400],
            cursor: "default",
            pointerEvents: "none",
            "& a": {
                color: Color.neutral[400],
            },
            "&:hover": {
                backgroundColor: Color.neutral[300],
            }
        },
        "&.MuiListItem-divider": {
            borderBottom: `1px solid ${Color.neutral[400]}`,
        },
    }),
    menuItemDivider: css({
        borderBottom: "2px solid red",
    }),
    text: css({
        alignItems: "center",
        display: "flex",
    }),
    arrowHeadIcon: css({
        position: "absolute",
        right: 0,
        paddingLeft: 10,
        color: Color.neutral[500],
    }),
    subMenu: css({
        minWidth: 200,
        borderRadius: 0,
        opacity: 0,
        position: "absolute",
        left: "100%",
        transform: "scale(1.75, 0.5625)",
        transformOrigin: "top right",
        transition: `opacity 0.3ms 0ms, transform 0.3ms 0ms`,
        top: 0,
        visibility: "hidden",
        boxShadow: "0px 2px 29px 0px rgba(3, 3, 3, 0.15)",
    }),
    subMenuListRoot: css({
        padding: 0,
    }),
    subMenuOpen: css({
        transform: "scale(1, 1) translateZ(0px)",
        visibility: "visible",
        opacity: 1,
    }),
    listItemIconRoot: css({
        minWidth: 0,
        marginTop: 4,
        marginRight: 8,
        color: Color.neutral[400],
    }),
});
